import clearIcon from '../../assets/svg/xStrokeIcon.svg';
import { ValidateFieldTypes, validationSchemeMap } from '../../helpers/inputUtils.helper';

export const STYLES = {
  INDEX: {
    WRAPPER: 'relative w-full h-fit bg-bw00 outline-none rounded-md',
    FILTER: 'w-full h-[50px] px-[16px] text-left outline-none rounded-md box-border border',
    FILTER_ACTIVE: 'border-action03',
    FILTER_INACTIVE: 'border-[#F2F4F7]',
  },
  VENDOR_PRESENTOR: {
    WRAPPER: 'w-full rounded-md border border-bw03',
    CHILDREN_WRAPPER:
      'relative flex items-center w-full h-full gap-2 bg-bw00 px-[16px] py-[8px] cursor-pointer hover:bg-bw02 rounded-md',
    ICON: 'absolute top-[50%] right-[16px] translate-y-[-50%]',
    ACTIONS_WRAPPER: 'flex items-center gap-2 pt-[10px]',
    ACTION: 'font-metricR text-[14px] hover:text-action04 text-action03',
    DIVIDER: 'text-bw03',
  },
  FLOAT_PICKER: {
    WRAPPER:
      'absolute z-50 overflow-y-auto flex flex-col max-h-[300px] bg-bw00 left-0 bottom-0 translate-y-[100%] w-full rounded-[8px] border border-bw03 shadow-bottomShadow fadeIn',
    CHILDREN:
      'flex items-center gap-3 cursor-pointer hover:shadow-light hover:bg-bw01 py-[10px] px-[16px] border-b border-bw02',
    CREATE_VENDOR:
      'font-metricR text-[14px] text-action03 flex items-center gap-3 cursor-pointer py-[14px] px-[16px] hover:underline',
    ZERO_STATE_WRAPPER:
      'absolute z-50 gap-1 flex flex-col items-center justify-center bg-bw00 py-[40px] left-0 top-0 translate-y-[50px] w-full rounded-[8px] border border-bw03 shadow-bottomShadow fadeIn',
    ZERO_STATE_HEADER: 'font-metricRMedium text-[16px] text-bw08',
    ADD_NEW_VENDOR: 'font-metricR text-[12px] text-action03 cursor-pointer hover:underline',
  },
};

export const FORM_FIELDS = {
  ACH_ROUTING_NUMBER: 'achRoutingNumber',
  ACH_ACCOUNT_NUMBER: 'achAccountNumber',
  WIRE_ACCOUNT_NUMBER: 'wireAccountNumber',
  WIRE_ROUTING_NUMBER: 'wireRoutingNumber',
  BUSINESS_NAME: 'businessName',
  EMAIL: 'email',
  LINE_ONE: 'lineOne',
  LINE_TWO: 'lineTwo',
  CITY: 'city',
  ZIP_CODE: 'zipCode',
  STATE: 'state',
};

export const BILL_PAY_FORM = [
  {
    type: 'single',
    inputType: 'text',
    name: 'MANAGE_VENDOR.FORM.BUSINESS_NAME',
    requiredMessage: 'Vendor name is required',
    validateScheme: /.{3,}/,
    validateErrorMessage: 'minimum 3 characters',
    inputId: FORM_FIELDS.BUSINESS_NAME,
    shouldValidateOnClick: true,
  },
  {
    type: 'single',
    inputType: 'text',
    name: 'MANAGE_VENDOR.FORM.EMAIL',
    requiredMessage: '',
    validateScheme: validationSchemeMap[ValidateFieldTypes.EMAIL],
    validateErrorMessage: 'Email format is invalid',
    inputId: FORM_FIELDS.EMAIL,
    shouldValidateOnClick: true,
  },
  {
    type: 'single',
    inputType: 'text',
    maxLen: 17,
    name: 'MANAGE_VENDOR.FORM.ACH_ACCOUNT',
    requiredMessage: '',
    validateScheme: /^[0-9]{5,17}$/,
    validateErrorMessage: 'Please enter a valid ACH Account Number',
    inputId: FORM_FIELDS.ACH_ACCOUNT_NUMBER,
    shouldValidateOnClick: true,
  },
  {
    type: 'single',
    inputType: 'text',
    maxLen: 9,
    name: 'MANAGE_VENDOR.FORM.ACH_ROUTE',
    requiredMessage: '',
    validateScheme: /^[0-9]{9}$/,
    validateErrorMessage: 'Please enter a valid ACH Routing Number',
    inputId: FORM_FIELDS.ACH_ROUTING_NUMBER,
    shouldValidateOnClick: true,
  },
  // {
  //   type: 'single',
  //   inputType: 'text',
  //   name: 'Wire Account Number', // Min 6 numbers only max 14
  //   requiredMessage: '',
  //   validateScheme: '',
  //   validateErrorMessage: '',
  //   inputId: FORM_FIELDS.WIRE_ACCOUNT_NUMBER,
  //   shouldValidateOnClick: false,
  // },
  // {
  //   type: 'single',
  //   inputType: 'text',
  //   name: 'Wire Routing Number', // equal to 9 Number only
  //   requiredMessage: '',
  //   validateScheme: '',
  //   validateErrorMessage: '',
  //   inputId: FORM_FIELDS.WIRE_ROUTING_NUMBER,
  //   shouldValidateOnClick: false,
  // },
  {
    type: 'single',
    inputType: 'text',
    header: {
      main: 'Address',
      silent: '(Optional)',
    },
    name: 'MANAGE_VENDOR.FORM.LINE_1',
    requiredMessage: '',
    validateScheme: /^[A-Za-z0-9-\s]+$/,
    validateErrorMessage: 'SUPPLIER.MANAGE.FORM.ADDRESS.VALIDATE',
    inputId: FORM_FIELDS.LINE_ONE,
    shouldValidateOnClick: true,
    clearIcon: {
      Asset: clearIcon,
      styles: 'stroke-bw01 w-[50%] h-[50%] mx-auto my-auto',
    },
  },
  {
    type: 'multiple',
    children: [
      {
        inputType: 'text',
        maxLen: 20,
        name: 'MANAGE_VENDOR.FORM.LINE_2',
        requiredMessage: '',
        validateScheme: '',
        validateErrorMessage: '',
        inputId: FORM_FIELDS.LINE_TWO,
        shouldValidateOnClick: true,
      },
      {
        inputType: 'text',
        name: 'MANAGE_VENDOR.FORM.ZIP',
        maxLen: 5,
        requiredMessage: '',
        validateScheme: /^[0-9]{5}$/,
        validateErrorMessage: 'SUPPLIER.MANAGE.FORM.ZIP.VALIDATE',
        inputId: FORM_FIELDS.ZIP_CODE,
        shouldValidateOnClick: true,
      },
    ],
  },
  {
    type: 'multiple',
    children: [
      {
        inputType: 'text',
        name: 'MANAGE_VENDOR.FORM.CITY',
        requiredMessage: '',
        validateScheme: /^[A-Za-z\s]+$/,
        validateErrorMessage: 'SUPPLIER.MANAGE.FORM.CITY.VALIDATE',
        inputId: FORM_FIELDS.CITY,
        shouldValidateOnClick: true,
      },
      {
        inputType: 'select',
        name: 'MANAGE_VENDOR.FORM.STATE',
        requiredMessage: '',
        defaultOption: 'MANAGE_VENDOR.FORM.STATE',
        inputId: FORM_FIELDS.STATE,
      },
    ],
  },
];

export const METHOD_TYPE_MAP = {
  BILL_PAY: null,
};
